<script>
import { fullscreenRoutes } from '@src/router'
import { useIndexStore } from '@src/store'
import Toolbar from '@comp/layout/Toolbar.vue'
import NavigationDrawer from '@comp/layout/NavigationDrawer.vue'
import Notification from '@comp/layout/Notification.vue'
import axios from 'axios'
import { jwtDecode } from 'jwt-decode'
import moment from 'moment-timezone'
import { refreshToken } from '@src/utils/auth'

export default {
  name: 'App',
  components: {
    Toolbar,
    NavigationDrawer,
    Notification,
  },
  computed: {
    pageWithNavigation () {
      const store = useIndexStore()
      return !fullscreenRoutes.map(route => route.name).includes(store.route)
    },
    containerClass () {
      return this.pageWithNavigation ? 'with-navigation' : 'without-navigation'
    },
  },
  created () {
    axios.interceptors.response.use(response => {
      if (localStorage.getItem('user-token') !== null) {
        const refreshTokenExp = jwtDecode(localStorage.getItem('user-token')).exp
        const expireIn = refreshTokenExp - moment().unix()
        if (expireIn < 180) {
          refreshToken().then(() => {
            console.log('refresh done')
          }).catch(error => {
            console.log('refresh buggy', error)
          })
        }
      }
      return response
    }, error => {
      return new Promise(() => {
        const store = useIndexStore()
        if (error.response.status === 401) {
          if (localStorage.getItem('user-token') !== null) {
            store.changeNotification({
              text: this.$gettext('Your session has expired, please login again'),
              autoClose: true,
              type: 'warning',
            })
          }
          this.$router.push('/login')
        }
        throw error
      })
    })
  },
}
</script>
<template>
  <v-app class="app">
    <NavigationDrawer v-if="pageWithNavigation" />
    <div
      class="container"
      :class="containerClass"
    >
      <Toolbar />
      <RouterView />
    </div>
    <Notification />
  </v-app>
</template>
